export type Notification = {
	id?: string
	type: NOTIFICATION_TYPE
	status: NOTIFICATION_STATUS
	message: string
	created: Date
	data?: NotificationData
	cover?: string
}

export type NotificationData = {
	userId?: string
	itineraryId?: string
	taskId?: string
	invitationCode?: string
	invitationUrl?: string
}

export enum NOTIFICATION_TYPE {
	TRIP_INVITATION_ACCEPTED = 'tripInvitationAccepted',
	TRIP_INVITATION_RECEIVED = 'tripInvitationReceived',
	TASK_ASSIGNED = 'taskAssigned',
	TRIP_DELETED = 'tripDeleted',
	TRIP_DATE_CHANGED = 'tripDateChanged',
	TRIP_TITLE_CHANGED = 'tripNameChanged',
	WALL_PIN_CREATED = 'wallPinCreated',
	WALL_PIN_DELETED = 'wallPinDeleted',
	BOOKING_CREATED = 'bookingCreated',
	SAVED_SPOT = 'savedSpot',
}

export enum NOTIFICATION_STATUS {
	UNREAD = 'unread',
	READ = 'read',
}
